import React, { useState } from 'react';
import { PackageCheck, Shirt, Bath } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const SeleccionarZonaModal = ({ isOpen, onClose, onZonaSeleccionada }) => {
  const [selectedZona, setSelectedZona] = useState(null);

  const zonas = [
    {
      id: 'Toallas',
      nombre: 'Toallas',
      descripcion: 'Alistamiento de toallas y productos de baño',
      icon: Bath,
      color: 'bg-blue-50 border-blue-200 hover:border-blue-400',
      iconColor: 'text-blue-600',
    },
    {
      id: 'Lenceria',
      nombre: 'Lencería',
      descripcion: 'Alistamiento de sábanas, fundas y lencería',
      icon: Shirt,
      color: 'bg-purple-50 border-purple-200 hover:border-purple-400',
      iconColor: 'text-purple-600',
    },
  ];

  const handleZonaClick = (zona) => {
    setSelectedZona(zona.id);
  };

  const handleContinuar = () => {
    if (selectedZona) {
      onZonaSeleccionada(selectedZona);
      setSelectedZona(null);
    }
  };

  const handleClose = () => {
    setSelectedZona(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-2xl">
            <PackageCheck className="h-6 w-6 text-purple-600" />
            Seleccionar Zona de Alistamiento
          </DialogTitle>
          <DialogDescription>
            Selecciona la zona donde se realizará el alistamiento
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
          {zonas.map((zona) => {
            const Icon = zona.icon;
            const isSelected = selectedZona === zona.id;

            return (
              <Card
                key={zona.id}
                className={`cursor-pointer transition-all ${zona.color} ${
                  isSelected ? 'ring-2 ring-offset-2 ring-purple-500' : ''
                }`}
                onClick={() => handleZonaClick(zona)}
              >
                <CardContent className="p-6">
                  <div className="flex flex-col items-center text-center gap-4">
                    <div className={`p-4 rounded-full bg-white`}>
                      <Icon className={`h-12 w-12 ${zona.iconColor}`} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg">{zona.nombre}</h3>
                      <p className="text-sm text-gray-600 mt-1">
                        {zona.descripcion}
                      </p>
                    </div>
                    {isSelected && (
                      <div className="mt-2">
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                          ✓ Seleccionada
                        </span>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="flex justify-end gap-2 pt-4 border-t">
          <Button variant="outline" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            onClick={handleContinuar}
            disabled={!selectedZona}
            className="bg-purple-600 hover:bg-purple-700"
          >
            Continuar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SeleccionarZonaModal;
